import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from '@environment';
import { WindowWithUser } from '@longnecktech/splash-commons-fe';
const url = new URL(window.location.href);

function isValidHexColor(color: string): boolean {
  // Check if the color matches the pattern for 3 or 6 digit hex colors
  return /^#?([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(color);
}

function getQueryParams() {
  const queryParams = new URLSearchParams(url.search);
  return {
    token: queryParams.get('token') ?? '',
    language: queryParams.get('language') ?? '',
    bg: queryParams.get('bg') ?? '',
  };
}

const { token, language: urlLang, bg } = getQueryParams();

if (token) {
  const bgColor = bg ? `#${bg}` : '';
  if (bgColor && isValidHexColor(bgColor)) {
    document.body.style.background = bgColor;
  }

  let selectedLanguage = urlLang || decodeTokenLang(token) || 'en';

  fetch(`${environment.backendUrl}/api/public/auth/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token, language: selectedLanguage }),
  })
    .then((response) => response.json())
    .then((data) => {
      (window as WindowWithUser).user = data;
      platformBrowserDynamic()
        .bootstrapModule(AppModule)
        .catch((err) => console.error(err));
    })
    .catch((error) => console.error('Authentication error:', error));
} else {
  console.warn('No token!');
}

function decodeTokenLang(token: string): string | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload?.language ?? null;
  } catch (err) {
    console.warn('Failed to decode JWT', err);
    return null;
  }
}
